import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Undo = (props) => (
  <Icon viewBox="0 0 16 15" {...props}>
    <g>
      <path d="M.666 6.31l2.565 2.584V5.885C3.231 2.64 5.922 0 9.231 0s6 2.641 6 5.887v8.782h-1V5.886c0-2.649-2.29-4.887-5-4.887-2.711 0-5 2.238-5 4.887v3.007L6.968 6.31l.741.716-3.828 3.751L0 7.027l.666-.717z"
        fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Undo;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Undo.js